import {defineComponent} from "vue";
import HinweisTO from "@/types/HinweisTO";
import EHinweis from "@/enums/EHinweis";
import NumberMixin from "@/mixins/NumberMixin";

export default defineComponent({
    mixins: [NumberMixin],
    methods: {
        getHinweisKaufpreisInRangeGesetzt: function (alterWert: number,
                                                     neuerWert: number,
                                                     min: number,
                                                     max: number): HinweisTO {
            let text = "";
            if (alterWert > max) {
                text = "Der Kaufpreis wurde von " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(alterWert) + " auf " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(neuerWert) + " reduziert, da der maximal zulässige Wert überschritten wurde.";
            } else if (alterWert < min) {
                text = "Der Kaufpreis wurde von " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(alterWert) + " auf " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(neuerWert) + " erhöht, da der minimal zulässige Wert unterschritten wurde.";
            }
            return {hinweisID: EHinweis.KAUFPREIS_WURDE_IN_RANGE_GESETZT, text: text} as HinweisTO;
        },
        getHinweisDarlehenInRangeGesetzt: function (alterWert: number,
                                                    neuerWert: number,
                                                    min: number,
                                                    max: number): HinweisTO {
            let text = "";
            if (alterWert > max) {
                text = "Der Darlehensbetrag wurde von " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(alterWert) + " auf " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(neuerWert) + " reduziert, da der maximal zulässige Wert überschritten wurde."
            } else if (alterWert < min) {
                text = "Der Darlehensbetrag wurde von " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(alterWert) + " auf " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(neuerWert) + " erhöht, da der minimal zulässige Wert unterschritten wurde.";
            }
            return {hinweisID: EHinweis.DARLEHEN_WURDE_IN_RANGE_GESETZT, text: text} as HinweisTO;
        },
        getHinweisRateInRangeGesetzt: function (alterWert: number,
                                                neuerWert: number,
                                                min: number,
                                                max: number): HinweisTO {
            let text = "";
            let hinweidId = {} as EHinweis;
            if (alterWert > max) {
                hinweidId = EHinweis.MONATLICHE_RATE_WURDE_REDUZIERT;
                text = "Die monatliche Rate wurde von " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(alterWert) + " auf " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(neuerWert) + " reduziert, da der maximal zulässige Wert überschritten wurde.";
            } else if (alterWert < min) {
                hinweidId = EHinweis.MONATLICHE_RATE_WURDE_ERHOEHT;
                text = "Die monatliche Rate wurde von " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(alterWert) + " auf " + this.convertNumberToHtmlWithTwoDigitsAndSuffixEuroIso(neuerWert) + " erhöht, da der minimal zulässige Wert unterschritten wurde.";
            }
            return {hinweisID: hinweidId, text: text} as HinweisTO;
        },
        getHinweisDarlehenAnBeleihungAngepasst: function (maxBeleihung: number): HinweisTO {
            const fehlertextDarlehen = "Der gewünschte Kredit darf maximal " + this.convertNumberWithDigits(maxBeleihung) + " Prozent der Bau-/Kaufkosten betragen. Deshalb wird das Darlehen entsprechend reduziert.";

            return {hinweisID: EHinweis.DARLEHEN_WURDE_AUF_MAX_BELEIHUNG_GESETZT, text: fehlertextDarlehen} as HinweisTO;
        }
    }
});
